/**
 * Apollo's add-on upsell.
 *
 * When the add-on checkbox is checked on a product page, the selected add-on
 * variant is added to the cart right after Dawn's own product form finishes
 * adding the main product (via the cartUpdate pub/sub event). Dawn's cart
 * logic is untouched — this only issues one extra /cart/add.js call and then
 * refreshes the cart icon bubble.
 */
(() => {
  if (window.ApollosAddonLoaded) return;
  window.ApollosAddonLoaded = true;

  let addingAddon = false;

  const refreshCartIcon = () =>
    fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const source = doc.querySelector('.shopify-section') || doc.body;
        const target = document.getElementById('cart-icon-bubble');
        if (target && source) target.innerHTML = source.innerHTML;
      });

  const onCartUpdate = (event) => {
    if (addingAddon) return;
    if (!event || event.source !== 'product-form') return;

    const checkbox = document.querySelector('[data-apollos-addon]');
    if (!checkbox || !checkbox.checked) return;

    // Only piggyback on the main product form of the section that rendered
    // the checkbox — not quick-add forms for other products on the page.
    const mainForm = document.getElementById(`product-form-${checkbox.dataset.sectionId}`);
    const idInput = mainForm ? mainForm.querySelector('[name="id"]') : null;
    if (idInput && event.productVariantId && Number(idInput.value) !== Number(event.productVariantId)) {
      return;
    }

    addingAddon = true;
    fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(checkbox.dataset.variantId), quantity: 1 }),
    })
      .then((response) => (response.ok ? response.json() : Promise.reject(new Error(`HTTP ${response.status}`))))
      .then(refreshCartIcon)
      .catch((error) => console.error('[apollos-addon] failed to add add-on product:', error))
      .finally(() => {
        addingAddon = false;
      });
  };

  const init = () => {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {
      console.warn('[apollos-addon] Dawn pub/sub not available; add-on disabled.');
      return;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
